var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","height":"100%"}},[_c('p',{staticStyle:{"margin":"auto"}},[_vm._v("请前往公众号打开个人中心里的'个人信息'页面")])])}]

export { render, staticRenderFns }